export class FacturaMetaData
{
	// Comprobante attributes
	Fecha: string = '';
	folio: string = '';
	total: string = '';
	moneda: string = '';
	noCertificado: string = '';
	lugarExpedicion: string = '';

	// TimbreFiscalDigital
	UUID: string = '';
	verificador: string = '';

	// Emisor
	emisor: string = '';
	rfcEmisor: string = '';

	// Receptor
	receptor: string = '';
	rfcReceptor: string = '';
	domicilioReceptor: string = '';

	constructor(xmlString: string)
	{
		if (!xmlString || xmlString.trim() === '')
		{
			return;
		}

		try
		{
			const parser = new DOMParser();
			const dom: XMLDocument = parser.parseFromString(xmlString, 'application/xml');

			// Parse Comprobante attributes
			const comprobante = dom.getElementsByTagName('cfdi:Comprobante');
			if (comprobante.length > 0)
			{
				const comp = comprobante.item(0) as Element;
				this.Fecha = comp.getAttribute('Fecha') || '';
				this.folio = comp.getAttribute('Folio') || '';
				this.total = comp.getAttribute('Total') || '';
				this.moneda = comp.getAttribute('Moneda') || '';
				this.noCertificado = comp.getAttribute('NoCertificado') || '';
				this.lugarExpedicion = comp.getAttribute('LugarExpedicion') || '';

				// Get last 8 characters of Sello for verification
				const sello = comp.getAttribute('Sello') || '';
				this.verificador = sello.slice(-8);
			}

			// Parse TimbreFiscalDigital for UUID
			const timbre = dom.getElementsByTagName('tfd:TimbreFiscalDigital');
			if (timbre.length > 0)
			{
				const tfd = timbre.item(0) as Element;
				this.UUID = tfd.getAttribute('UUID') || '';
			}

			// Parse Emisor
			const emisorElements = dom.getElementsByTagName('cfdi:Emisor');
			if (emisorElements.length > 0)
			{
				const emisorEl = emisorElements.item(0) as Element;
				this.emisor = emisorEl.getAttribute('Nombre') || '';
				this.rfcEmisor = emisorEl.getAttribute('Rfc') || '';
			}

			// Parse Receptor
			const receptorElements = dom.getElementsByTagName('cfdi:Receptor');
			if (receptorElements.length > 0)
			{
				const receptorEl = receptorElements.item(0) as Element;
				this.receptor = receptorEl.getAttribute('Nombre') || '';
				this.rfcReceptor = receptorEl.getAttribute('Rfc') || '';
				this.domicilioReceptor = receptorEl.getAttribute('DomicilioFiscalReceptor') || '';
			}
		}
		catch (error)
		{
			console.error('Error parsing CFDI XML:', error);
		}
	}
}
